import { render } from "./apiDocStanded.vue?vue&type=template&id=57de74f8&scoped=true"
import script from "./apiDocStanded.vue?vue&type=script&lang=js"
export * from "./apiDocStanded.vue?vue&type=script&lang=js"

import "./apiDocStanded.vue?vue&type=style&index=0&id=57de74f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57de74f8"]])

export default __exports__